import { render, staticRenderFns } from "./sopDetail.vue?vue&type=template&id=581df2dc&scoped=true&"
import script from "./sopDetail.vue?vue&type=script&lang=js&"
export * from "./sopDetail.vue?vue&type=script&lang=js&"
import style0 from "./sopDetail.vue?vue&type=style&index=0&id=581df2dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581df2dc",
  null
  
)

export default component.exports